// extracted by mini-css-extract-plugin
export default {"videoItem":"videoItem__UR4br"};